/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Inject, Injectable} from '@angular/core';
import * as fileSaver from 'file-saver-es';
import {Observable} from 'rxjs';
import {catchError, take} from 'rxjs/operators';
import {Environment} from '../interfaces/Environment';
import {Picture} from '../interfaces/Picture';
import {BaseService} from './base.service';
import {CompoApiService} from './compo-api.service';

@Injectable({
  providedIn: 'root',
})
export class FileService extends BaseService {
  constructor(@Inject('environment') private readonly environment: Environment,
              private readonly apiService: CompoApiService
  ) {
    super();
  }

  static saveAs(data: Blob, fileName: string, mimeType: string = 'application/octet-stream'): void {
    const blob = new Blob([data], {type: mimeType});
    fileSaver.saveAs(blob, fileName);
  }

  getImageUri(picture: Picture, width?: number | string): string {
    const dir = width === undefined ? this.environment.originalsImagesFolder : width;
    return this.environment.serverPicturesPath + '/' + dir + '/' + picture.name + '.' + picture.type;
  }

  getImageSrc(picture: string, width?: number | string): string {
    const dir = width === undefined ? this.environment.originalsImagesFolder : width;
    return this.environment.serverPicturesPath + '/' + dir + '/' + picture;
  }

  getPublicDocumentUri(fileName: string): string {
    return this.environment.serverDocumentsPath + '/' + fileName;
  }

  downloadUrl(url: string): Observable<Blob> {
    return this.apiService.downloadUrl(url).pipe(catchError(err => this.handleError(err)), take(1));
  }

  downloadPostUrl<T>(url: string, data: T): Observable<Blob> {
    return this.apiService.downloadPostUrl(url, data).pipe(catchError(err => this.handleError(err)));
  }

}
